import { Icon } from "@iconify/react";
import React, { useState, useEffect } from "react";

const Iconify: React.FC<{
  icon: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}> = ({ icon, size = 24, className = "", onClick }) => {
  return (
    <div
      onClick={() => {
        onClick && onClick();
      }}
      className={className}
      style={{
        width: size + "px",
        height: size + "px",
      }}
    >
      <Icon icon={icon} width={size} height={size} />
    </div>
  );
};

export default Iconify;
